import React from 'react';
import classnames from 'classnames/bind';
import familyMemoirBookSrc from '../../assets/images/slide/family-memoir-book.png';
import memoirPreviewTimelineSrc from '../../assets/images/slide/memoir-preview-timeline.png';
import styles from './PlanGraphSlideV3.css';

const cx = classnames.bind(styles);

const MONTHS_SHOWN = 4;
const monthFormatter = new Intl.DateTimeFormat('en-US', { month: 'long' });

function getUpcomingMonths() {
    const now = new Date();

    return Array.from({ length: MONTHS_SHOWN }, (_, index) => monthFormatter.format(new Date(now.getFullYear(), now.getMonth() + index, 1)));
}

const JOURNEY_STEPS = [
    {
        title: 'Start whenever you want',
        description: 'You’ll answer each question in your own time, with no pressure or deadlines — just simple moments to reflect on the experiences that shaped you.'
    },
    {
        title: 'Watch your memories become a story',
        description: 'Our team shapes your words into a warm, clear, beautifully structured memoir.'
    },
    {
        title: 'Open your finished memoir anywhere',
        description: 'A professionally printed memoir, ready to share with your family and future generations.'
    }
];

function PlanGraphSlideV3() {
    const months = getUpcomingMonths();

    return (
        <div className={styles.form}>
            <div className={styles.imageCard}>
                <img src={familyMemoirBookSrc} alt='' className={styles.image} />
            </div>
            <div className={styles.headingSection}>
                <h2 className={styles.heading}>In Just 3 Months, this could be Your Family Memoir</h2>
                <span className={styles.badge}>No writing skills needed</span>
            </div>
            <p className={styles.description}>Turning your memories into a book doesn’t have to be hard. You tell the stories, we shape them into a book you’ll be proud of.</p>
            <div className={styles.previewSection}>
                <div className={styles.previewCard}>
                    <div className={styles.previewHeading}>
                        <p className={styles.previewTitle}>Your memoir in <span className={styles.previewTitleAccent}>{months[months.length - 1]}</span></p>
                        <p className={styles.previewSubtitle}>Built chapter by chapter, with photos</p>
                    </div>
                    <img src={memoirPreviewTimelineSrc} alt='' className={styles.timeline} />
                    <div className={styles.months}>
                        {months.map((month, index) => (
                            <span key={month} className={cx('month', { monthActive: index === 0 })}>{month}</span>
                        ))}
                    </div>
                </div>
                <p className={styles.caption}>Illustrative timeline. Your pace is your own.</p>
            </div>
            <div className={styles.journeySection}>
                <h2 className={styles.journeyHeading}>You tell it. We write it. That's the arrangement.</h2>
                <ul className={styles.journeyList}>
                    {JOURNEY_STEPS.map((step, index) => (
                        <li key={step.title} className={styles.journeyStep}>
                            <span className={styles.journeyNumber}>{index + 1}</span>
                            <div className={styles.journeyCopy}>
                                <p className={styles.journeyTitle}>{step.title}</p>
                                <p className={styles.journeyDescription}>{step.description}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export {
    PlanGraphSlideV3
};
